import { useState } from "react";

type RollerLiftTransferControlsProps = {
  disabled?: boolean;
  initialHeight: number;
  onHeightChange: (height: number) => void;
};

export function RollerLiftTransferControls({
  disabled = false,
  initialHeight,
  onHeightChange
}: RollerLiftTransferControlsProps) {
  const [heightDraft, setHeightDraft] = useState(String(initialHeight));

  return (
    <div className="roller-lift-transfer-controls">
      <span className="roller-lift-transfer-controls-title">辊道顶升移载</span>
      <label className="roller-lift-transfer-controls-field">
        <span>整体 Y 高度</span>
        <span className="roller-lift-transfer-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setHeightDraft(nextDraft);
              if (Number.isFinite(nextValue)) {
                onHeightChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={heightDraft}
          />
          <span>m</span>
        </span>
      </label>
    </div>
  );
}
